







import Vue from "vue";
import Component from "vue-class-component";

import { Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class Alert extends Vue {
  static listType = {
    info: "info",
    success: "success",
    warning: "warning",
    error: "error",
  };
  @Prop({ default: null }) text;
  @Prop({ default: null }) type;

  mounted() {}
  get imagePath() {
    return `content/images/svg/icon-${this.type}.svg`;
  }
}
